import {makeAutoObservable} from "mobx"
import {validationStore} from "../ValidationStore";
import {api, catchApi} from "../../api";
import {equals} from "../../utils";
import {
    ScanDocumentRuleActionTypeDto,
    ScanDocumentRuleDetailDto,
    ScanDocumentRuleFieldTypeDto
} from "../../api/cms";

class CmsRuleDetailStore {

    get field(): ScanDocumentRuleFieldTypeDto {
        return this._field;
    }

    set field(value: ScanDocumentRuleFieldTypeDto) {
        this._field = value;
    }

    get action(): ScanDocumentRuleActionTypeDto {
        return this._action;
    }

    set action(value: ScanDocumentRuleActionTypeDto) {
        this._action = value;
    }
    get customerId(): string {
        return this._customerId;
    }

    set customerId(value: string) {
        this._customerId = value;
    }
    
    get data(): ScanDocumentRuleDetailDto | undefined {
        return this._data;
    }

    set data(value: ScanDocumentRuleDetailDto | undefined) {
        this._data = value;
    }
    get value(): string {
        return this._value;
    }

    set value(value: string) {
        this._value = value;
    }

    get saving(): boolean {
        return this._saving
    }

    set saving(value: boolean) {
        this._saving = value
    }

    get valid(): boolean {
        return this._valid
    }

    set valid(value: boolean) {
        this._valid = value
    }

    get name(): string {
        return this._name
    }

    set name(value: string) {
        this._name = value
    }

    get id(): string {
        return this._id
    }

    set id(value: string) {
        this._id = value
    }

    get dirty(): boolean {
        const current = this.build()
        return !equals(this.data, current)
    }

    private _id: string = ''
    private _customerId: string = ''
    private _creating: boolean = false
    private _valid: boolean = false

    private _saving: boolean = false
    private _name: string = ''
    private _field: ScanDocumentRuleFieldTypeDto = ScanDocumentRuleFieldTypeDto.DOCUMENT_TYPE
    private _value: string = ''
    private _action: ScanDocumentRuleActionTypeDto = ScanDocumentRuleActionTypeDto.DESTROY
    private _data: ScanDocumentRuleDetailDto | undefined


    constructor() {
        makeAutoObservable(this)
    }

    async load(): Promise<boolean> {
        const result = await catchApi(async () =>
            await api.cms.api.getScanDocumentRule(this.id, this.customerId))
        this.data = result?.data
        this.reset()
        return Boolean(result);
    }

    public reset() {
        const {
            name,
            field,
            value,
            action
        } = this.data?.data || {}

        this.name = name || ''
        this.field = field || ScanDocumentRuleFieldTypeDto.DOCUMENT_TYPE
        this.value = value || ''
        this.action = action || ScanDocumentRuleActionTypeDto.DESTROY
        this.data = this.build() // delete all non used fields like created date
    }

    async validate() {
        this.valid = false
        const dto = this.build()

        const validateMethod = () => {
            return api.cms.api.validateScanDocumentRule(this.customerId, dto)
        }
        await validationStore.validate(validateMethod, dto)
        this.valid = validationStore.valid
    }

    public build(): ScanDocumentRuleDetailDto {
        const {
            name,
            field,
            value,
            action,
        } = this
        return {
            data: {
                name,
                field,
                value,
                action,
            }
        }
    }

    async save() {
        const dto = this.build()
        this.saving = true
        const result = await catchApi(async () =>
            await api.cms.api.updateScanDocumentRule(this.id, this.customerId, dto))
        this.data = result?.data!! as ScanDocumentRuleDetailDto
        this.reset()
        this.saving = false
    }
}

const cmsRuleDetailStore = new CmsRuleDetailStore()

export {
    cmsRuleDetailStore
}
